import type { ReactNode } from 'react';
import { GlobalRule } from '@/components/base/Frame';

interface ChapterProps {
  id: string;
  children: ReactNode;
  headerGap?: boolean;
  className?: string;
}

/* Same outer gaps + full-width chapter rules as Frame's Section, but content-sized (no 100svh lock). */
export default function Chapter({ id, children, headerGap = false, className = '' }: ChapterProps) {
  return (
    <section id={id} className={`relative flex flex-col pb-10 md:pb-14 ${headerGap ? 'pt-16 md:pt-20' : 'pt-10 md:pt-14'}`}>
      <div className={`relative flex flex-1 flex-col ${className}`}>
        <GlobalRule position="top" />
        {children}
        <GlobalRule position="bottom" />
      </div>
    </section>
  );
}